"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeB2BMarkupCookie = exports.setB2BMarkupCookie = exports.getB2BMarkupCookie = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const libs_context_req_ctx_1 = require("@hotelplan/libs.context.req-ctx");
const libs_utils_1 = require("@hotelplan/libs.utils");
function getB2BMarkupCookie() {
    if (typeof window !== 'undefined') {
        const b2bMarkup = js_cookie_1.default.get(libs_context_req_ctx_1.B2B_MARKUP_KEY);
        return b2bMarkup ? +b2bMarkup : undefined;
    }
    return undefined;
}
exports.getB2BMarkupCookie = getB2BMarkupCookie;
function setB2BMarkupCookie(markup) {
    if (typeof window !== 'undefined') {
        js_cookie_1.default.set(libs_context_req_ctx_1.B2B_MARKUP_KEY, markup.toString(), {
            path: '/',
            expires: (0, libs_utils_1.getTomorrowsDate)(),
        });
    }
}
exports.setB2BMarkupCookie = setB2BMarkupCookie;
function removeB2BMarkupCookie() {
    if (typeof window !== 'undefined') {
        js_cookie_1.default.remove(libs_context_req_ctx_1.B2B_MARKUP_KEY);
    }
}
exports.removeB2BMarkupCookie = removeB2BMarkupCookie;
//# sourceMappingURL=B2BMarkupForm.utils.js.map